<template>
  <b-modal
    id="modal-add-report"
    :title="$t('courses.add_report')"
    cancel-variant="outline-secondary"
    :ok-title="$t('add')"
    :ok-variant="'success'"
    :cancel-title="$t('cancel')"
    centered
    no-close-on-backdrop
    @ok="onSubmitCategory"
  >
    <b-form>
      <validation-observer ref="reportValidation">
        <b-form-group :label="$t('title')">
          <validation-provider
            #default="{ errors }"
            :name="$t('title')"
            rules="required"
          >
            <b-form-input :placeholder="$t('title')" v-model="title" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BTabs,
  BTab,
  BFormDatepicker,
  BFormFile,
  BFormTextarea,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@validations";
import { mapActions } from "vuex";
import vSelect from "vue-select";

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BTabs,
    BTab,
    BFormFile,
    vSelect,
    BFormDatepicker,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
  },

  data() {
    return {
      required,
      title: null,
    };
  },
  methods: {
    ...mapActions("contacts", ["CREATE_REPORT", "FETCH_ALL_REPORT_LIST"]),

    onSubmitCategory(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.$refs.reportValidation.validate().then((success) => {
        if (!success) {
          return;
        }

        try {
          this.CREATE_REPORT({ title: this.title }).then((res) => {
            this.FETCH_ALL_REPORT_LIST();
          });
          this.$nextTick(() => {
            this.$bvModal.hide("modal-add-report");
          });

          this.title = "";

          this.$_okToast();
        } catch (err) {
          this.$_errToast(err);
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============
  },
};
</script>

<style scoped>
</style>
